export default __webpack_public_path__ + "4a77cc44538ad95340bd13d62a123712.png";